/**
 * Ссылки и пороги окна «Оборудование». Ссылка — содержимое окна, а не знание агента: агент только говорит с оборудованием
 * и с этим сайтом, поэтому адреса скачивания живут здесь, в настройках приложения, и меняются без касания агента.
 * Каждую можно переопределить при сборке переменной окружения Vite; нет значения и нет умолчания — кнопка не показывается.
 */

/** Центр загрузок АТОЛ, раздел «Программное обеспечение → ДТО»: там «Драйвер ККТ 10». */
const ATOL_DRIVER_DEFAULT =
  'https://fs.atol.ru/SitePages/%D0%A6%D0%B5%D0%BD%D1%82%D1%80%20%D0%B7%D0%B0%D0%B3%D1%80%D1%83%D0%B7%D0%BA%D0%B8.aspx' +
  '?raz1=%u041f%u0440%u043e%u0433%u0440%u0430%u043c%u043c%u043d%u043e%u0435+%u043e%u0431%u0435%u0441%u043f%u0435%u0447%u0435%u043d%u0438%u0435&raz2=%u0414%u0422%u041e'

/** Установщик программы-драйвера (агента) на этот компьютер. Пока не выложен — кнопки нет (`VITE_AGENT_DOWNLOAD_URL`). */
export const AGENT_INSTALLER_URL: string | null = import.meta.env.VITE_AGENT_DOWNLOAD_URL ?? null

/**
 * Какой уровень возможностей агента (`hello.api.level`) нужен окну. Третий уровень: есть `GET /v1/drivers` и
 * `POST /v1/equipment/scan` (docs/CONTRACT.md агента). Агент ниже — «версия устарела», окно показывает только то, что он умеет.
 */
export const AGENT_MIN_API_LEVEL = 3

/** Версия агента, которую рекомендует приложение (`VITE_AGENT_RECOMMENDED_VERSION`): «есть новее», работу не блокирует. */
export const AGENT_RECOMMENDED_VERSION: string | null = import.meta.env.VITE_AGENT_RECOMMENDED_VERSION ?? null

/**
 * Ссылки скачивания драйверов по id драйвера (`atol-kkt`, `inpas-dual-connector`, …; id отдаёт агент в `GET /v1/drivers`).
 * Нет ссылки — кнопки «Скачать драйвер» нет, а подсказка в карточке всё равно говорит, что поставить.
 * «Драйвер ККТ 10»: `VITE_ATOL_DRIVER_URL` переопределяет умолчание. INPAS Dual Connector: адрес установщика даёт банк или INPAS
 * (`VITE_INPAS_DUAL_CONNECTOR_URL`).
 */
export const DRIVER_LINKS: Readonly<Record<string, string | null>> = {
  'atol-kkt': import.meta.env.VITE_ATOL_DRIVER_URL ?? ATOL_DRIVER_DEFAULT,
  'inpas-dual-connector': import.meta.env.VITE_INPAS_DUAL_CONNECTOR_URL ?? null,
}
